const personalData = {
    title: '',
    firstName: '',
    lastName: '',
    middleName: '',
    birth: '',
    ssn: '',
    confirmSsn: '',
    phone: '',
    maritalStatus: '',
    idenType: '',
    idenNumber: '',
    issueDate: '',
    expDate: '',
    permAddress: '',
    address2: '',
    city: '',
    country: '',
    zipCode: '',
    state: '',
    mailingCountry: '',
    mailingAddress: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingZipCode: '',
    mailingState: '',
    trustName: '',
    trustCountry: '',
    isMailingAddressDifferent: false,
    mailingDiff: '',
    checkboxChecked: false,
    upload: '',
};

const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO'
const SET_CHECKBOX_STATE = 'SET_CHECKBOX_STATE';

export const setPersonalData = (personalData) => ({
    type: SET_PERSONAL_INFO,
    payload: personalData,
});

export const setCheckboxState = (checked) => ({
    type: SET_CHECKBOX_STATE,
    payload: checked,
});

const personal_store = (state = personalData, action) => {
    switch (action.type) {
        case SET_PERSONAL_INFO:
            return {
                ...state,
                ...action.payload,
            }
        case SET_CHECKBOX_STATE:
            return {
                ...state,
                checkboxChecked: action.payload,
            };
        default:
            return state;
    }
};

export default personal_store;